<template>
  <div>
    <transition-group tag="ul" name="list" :class="listClass">
      <li
        v-for="(item, index) in result"
        v-bind:key="getKey(item)"
        class="list-item"
        :class="itemClass">
        <slot :item="item" :index="index" />
      </li>
    </transition-group>
    <div v-if="list.length > 0 && showMore" class="text-center mb-2">
      <small>Visar {{ pagination.to }} av {{ pagination.of }}</small>
    </div>
    <slot name="more" v-if="hasMore && showMore" v-bind:more="gotoNext">
      <div>
        <button id="showMoreBtn" @click="gotoNext()">Visa fler</button>
      </div>
    </slot>

    <div v-if="!showMore" class="flex justify-center">
      <Button size="large" type="primary" href="/sok-ledigt" class="w-fit">
        Se alla lediga objekt
      </Button>
    </div>

  </div>
</template>

<script>
import Button from '@/components/ui/button';
export default {
  name: 'AppendableListSearch',
  components: { Button },
  props: {
    ky: {
      type: [String, Array],
      required: true,
    },
    list: {
      type: Array,
      default: [],
    },
    page: {
      type: Number,
      default: 1,
    },
    size: {
      type: Number,
      default: 5,
    },
    listClass: {
      type: String,
      default: '',
    },
    itemClass: {
      type: String,
      default: '',
    },
    showMore: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      append: true,
      pageMutable: 1, // om inte page finns, används denna internt enbart. annars skrivs den över i watch.
    };
  },

  watch: {
    /**
     * Ändrars page, ändras pageMutable, men pageMutable är inte beroende av att page existerar för att ha koll på räkningen.
     */
    page: {
      immediate: true,
      handler(page) {
        this.pageMutable = page;
      },
    },
  },

  computed: {
    result() {
      return this.list.slice(this.from, this.to);
    },
    from() {
      if (this.append) return 0;

      return (this.pageMutable - 1) * this.size;
    },

    to() {
      if (this.append) return this.pageMutable * this.size;

      return this.from + this.size;
    },
    hasMore() {
      return this.to < this.list.length;
    },
    pagination() {
      return {
        to: this.to < this.list.length ? this.to : this.list.length,
        of: this.list.length,
      };
    },
  },
  created() {},
  methods: {
    getKey(item) {
      let fields = this.ky instanceof Array ? this.ky : [this.ky];

      let key = '';
      fields.forEach((field) => {
        let _fields = field.split('.');

        // errorreport.areaCode
        if (_fields.length == 2) key += item[_fields[0]][_fields[1]];
        // areaCode
        else key += item[_fields[0]];
      });

      return key;
    },

    gotoNext() {
      this.$emit('change', ++this.pageMutable);
      $('#showMoreBtn').focus();
    },
  },
};
</script>
